import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IIntegrationAppsResponse } from "../../interfaces";

export const useIntegrationApps = (trackingId?: string, refetchInterval?: number | false) => {
  return useQuery({
    queryKey: ["integration-apps", trackingId ?? "all"],
    queryFn: async () => {
      return httpService.get<IIntegrationAppsResponse>(
        API_CONFIG.path.integrationApps,
        trackingId ? { tracking_id: trackingId } : {}
      );
    },
    refetchInterval: refetchInterval ?? false,
  });
};
